import {Component, Input, OnInit} from '@angular/core';
import {DeviceMeasurement} from "../../../../../model/device-measurement";
import {DefaultDeviceCatalog} from "../../../../../model/default-device-catalog";

@Component({
  selector: 'app-default-device-sensors',
  templateUrl: './default-device-sensors.component.html',
  styleUrls: ['./default-device-sensors.component.scss']
})
export class DefaultDeviceSensorsComponent implements OnInit {

  @Input()
  public defaultDeviceCatalog: DefaultDeviceCatalog;

  public measurements: DeviceMeasurement[];
  public totalMeasurements: number;
  public loadingMeasurements: boolean;

  public rows = 10;
  public first = 0;

  constructor() {
    this.measurements = [];
  }

  ngOnInit(): void {
    this.loadMeasurements();
  }

  private loadMeasurements() {
    this.loadingMeasurements = true;
    if (this.defaultDeviceCatalog) {
      this.measurements = this.defaultDeviceCatalog.content?.deviceMeasurements ? this.defaultDeviceCatalog.content.deviceMeasurements : [];
    }
    this.totalMeasurements = this.measurements.length;
    this.loadingMeasurements = false;
  }

}
